document.addEventListener('DOMContentLoaded', function () {
  const asideMenu = document.querySelector('.aside-menu');
  if (!asideMenu) return;

  // Fånga ALLA klick inne i aside-menyn i capture-fasen
  document.addEventListener(
    'click',
    function (event) {
      // Bry dig bara om klick som sker inne i aside-menyn
      if (!asideMenu.contains(event.target)) return;

      // Leta upp närmaste länk i aside-menyn
      const link = event.target.closest(
        'a.aside-menu__item--grandchild, a.aside-menu__link'
      );
      if (!link) return;

      // Bara när menyn faktiskt är öppen
      if (!asideMenu.classList.contains('aside-menu--open')) return;

      const href = link.getAttribute('href');
      if (!href || href === '#') return;

      // STOPPA all annan klicklogik och navigera själv
      event.preventDefault();
      event.stopImmediatePropagation();
      event.stopPropagation();

      window.location.href = href;
    },
    true // <= capture: true (körs före alla andra lyssnare)
  );
});
